<template>
<div class="layout-section">
    <!-- *** Group Control Here *** -->
    <!-- <div v-if="!element.hideTitle" class="section-title" :data-key="element.key">
        <div>
            {{element.title}}
        </div>
        <div>
            <div>
                <v-menu left offset-y :nudge-bottom="6">
                    <template v-slot:activator="{ on }">
                    <v-btn style="margin:-4px 0" v-on="on" text icon color="grey lighten-1"><v-icon>arrow_drop_down_circle</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="">
                            <v-list-item-title>Menu Text</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

            </div>
        </div>
    </div>
    <div class="panel" :class="{'raised': !element.flat, 'white-background': !element.flat}">
        <template v-if="!element.control">
            <slot>
                <ElementControl v-for="child in element.elements" :element="child" :parent="element" :key="child.key" />
            </slot>
            <ul class="link-button-group">
                <li @click="$set(child, 'viewNaFields', true)" v-if="fieldsNotApplicable.length && !element.viewNaFields">{{fieldsNotApplicable.length}} NA fields</li>
                <li @click="$set(child, 'viewNaFields', false)" v-if="element.viewNaFields && fieldsNotApplicable.length">Hide NA fields</li>
            </ul>
        </template>
        <template v-else>
            <ScreenTable :table="child.table" />
            
        </template>
    </div> -->
</div>
</template>

<script>
import DataHelpers from '../../helpers/DataHelpers'
import ElementLayout from '../ElementLayout'
import ElementControl from '../ElementControl'
import ScreenHelpers from '../ScreenHelpers'
import ScreenTable from '../ScreenTable'

export default {
    data() {
        return {

        }
    },

    components: {
        ElementLayout,
        ElementControl,
        ScreenTable,
    },
    
    props: {
        element: Object,
    },

    computed: {
        fieldsNotApplicable() {
            return this.element.elements.filter(o => o.na)
        },
        valid() {
            return ScreenHelpers.isSectionValid(this.element)
        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>

.link-button-group {
    margin:0;padding:0;
}

.link-button-group li {
    display: inline-block;
    padding:2px 6px;
    color: #1565C0;
    border-right:solid 1px #ccc;
}

.link-button-group li:last-of-type {
    border-right-color: transparent;
}

.link-button-group li:hover {
    background-color: #BBDEFB;
    cursor:pointer;
    border-radius:12px;
    border-right-color: transparent;

}

.layout-section {
    margin: 0 4% 5px 4%;
    max-width:850px;
}
.section-title {
    font-family: 'Google Sans', Roboto;
    font-weight: 400;
    font-size: 18px;
    color: #70757a;
    padding: 10px 0;
    display:flex;
    width:100%;
}

.section-title>div:first-child {
    flex-grow:1;
}

.section-title>div:last-child {
    flex-basis:35px;
    /* border:solid 1px red; */
    text-align:right;
}

.panel {

    padding:10px 5px 10px 10px;
    border-radius: 3px;
}

@media(max-width:600px) {
    .layout-section {
        margin: 0 0 5px 0;
    }
    .panel {
        box-shadow: none;
        border-radius:0;
    }
    .section-title {
        padding-left:10px;
    }
}


</style>




// WEBPACK FOOTER //
// GroupControl.vue?781d7bf8